module.exports = __webpack_public_path__ + "static/img/illustratepic_01.cd0a1a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh-TW/illustratepic_01.png
// module id = eRzz
// module chunks = 1